import { render } from "./MobileDefault.vue?vue&type=template&id=70fb917c&scoped=true"
import script from "./MobileDefault.vue?vue&type=script&lang=js"
export * from "./MobileDefault.vue?vue&type=script&lang=js"

import "./MobileDefault.vue?vue&type=style&index=0&id=70fb917c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fb917c"]])

export default __exports__